import { FilteredAccount, IClientAccounts } from '@interfaces/models/client-accounts.interface';
import { createAction, props } from '@ngrx/store';

export const LoadClientAccounts = createAction('[Client Accounts] Load Client Accounts');

export const LoadClientAccountsStop = createAction('[Client Accounts] Load Client Accounts Stop');

export const LoadClientAccountsFail = createAction(
  '[Client Accounts] Load Client Accounts Fail',
  props<{ payload: unknown }>(),
);

export const LoadClientAccountsSuccess = createAction(
  '[Client Accounts] Load Client Accounts Data Success',
  props<{ payload: IClientAccounts }>(),
);

export const UpdateDisplayedAccounts = createAction(
  '[Client Accounts] Update Client Accounts',
  props<{ payload: FilteredAccount[] }>(),
);
